import { invokeSharedDvlaVehicleLookup } from '../../ui-foundation';
import { supabase } from '@/integrations/supabase/client';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export async function invokeDvlaVehicleLookup(registrationNumber: string) {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  return invokeSharedDvlaVehicleLookup({
    supabaseUrl: SUPABASE_URL,
    publishableKey: SUPABASE_PUBLISHABLE_KEY,
    accessToken: session?.access_token ?? null,
    registrationNumber,
  });
}
